import { MantineTheme } from "@mantine/core";
import { DataMapMarkerProps, latLng, ValuesRecord } from "@mcurros2/microm";

export function TiendasVisitasPersonalViewMarkerRenderer(record: ValuesRecord, position: latLng, theme: MantineTheme): DataMapMarkerProps | null {

    const tienda = record[2] as string;
    const visitas = record[6] as string;
    const checkin = record[7] as boolean;
    const checkout = record[9] as boolean;

    let color = theme.colors.red[8]
    let descripcion = '';

    if (checkout) {
        color = theme.colors.green[6];
        descripcion = 'Visita Finalizada';
    } else if (checkin) {
        color = theme.colors.orange[6];
        descripcion = 'Visita Iniciada';
    } else {
        descripcion = 'Sin Iniciar';
    }

    const markerProps: DataMapMarkerProps = {
        position: position,
        title: `${tienda} - ${visitas} - ${descripcion}`,
        assignColorByValue: undefined,
        fillColor: color,
    }

    return markerProps;
}